export enum ErrorCode {
  None = 0,
  AuthFailed = 1,
  NoPermissionForCommand = 3,
}
